import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Roles } from '@sp-core/agreement-keys/roles.enum';
import { DisclaimerPopupComponent } from '@sp-shared/containers/disclaimer-popup/containers/disclaimer-popup/disclaimer-popup.component';

@Injectable({
  providedIn: 'root',
})
export class DisclaimerService {
  private static readonly STORAGE_KEY = 'sp_disclaimer_accepted';

  private static readonly DISCLAIMER_ROLES: ReadonlyArray<string> = [
    Roles.provider,
    Roles.dosingProvider,
    Roles.limitedProvider,
    Roles.starterProvider,
  ];

  constructor(private dialog: MatDialog) {}

  public ensureAccepted(role: IRole): Observable<boolean> {
    if (!role || !DisclaimerService.DISCLAIMER_ROLES.includes(role.key)) {
      return of(true);
    }
    if (this.isAccepted()) {
      return of(true);
    }
    return this.dialog
      .open(DisclaimerPopupComponent, {
        disableClose: true,
        panelClass: 'sp-disclaimer-popup',
        backdropClass: 'sp-disclaimer-backdrop',
      })
      .afterClosed()
      .pipe(
        map(() => {
          this.markAccepted();
          return true;
        }),
      );
  }

  public clearAcceptance(): void {
    localStorage.removeItem(DisclaimerService.STORAGE_KEY);
  }

  private isAccepted(): boolean {
    return localStorage.getItem(DisclaimerService.STORAGE_KEY) === 'true';
  }

  private markAccepted(): void {
    localStorage.setItem(DisclaimerService.STORAGE_KEY, 'true');
  }
}
